import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import DiscoveryCallAgenda from "@/components/DiscoveryCallAgenda";

// Inline booking section for the bottom of service pages.
const InlineBookingCTA = ({ serviceLabel }: { serviceLabel?: string }) => (
  <section className="section-padding bg-accent/40">
    <div className="container-narrow">
      <div className="grid gap-8 lg:grid-cols-[1.1fr_1fr] lg:items-center">
        <div>
          <div className="gold-divider" />
          <h2 className="mt-4 font-display text-3xl font-bold text-foreground md:text-4xl">
            Book your free strategy call
          </h2>
          <p className="mt-3 text-muted-foreground">
            {serviceLabel
              ? `30 minutes on ${serviceLabel.toLowerCase()}, how it would run for your market, what it would cost, and what it should produce.`
              : "30 minutes on your pipeline, what to build first, what it would cost, and what it should produce."}
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/book">
              <Button size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 cta-glow font-semibold">
                Pick a Time <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <a href="tel:+12142962124">
              <Button size="lg" variant="outline">
                <Phone className="mr-2 h-4 w-4 text-secondary" /> (214) 296-2124
              </Button>
            </a>
          </div>
          <p className="mt-3 text-xs text-muted-foreground">
            Replies within 1 business day · Hours 9 AM, 5 PM ET, 7 days a week
          </p>
        </div>
        <DiscoveryCallAgenda />
      </div>
    </div>
  </section>
);

export default InlineBookingCTA;
